// import icons
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaDiscord,
} from 'react-icons/fa';
// import images
import AboutImg from '../src/assets/img/about/plate.png';
import MenuImg1 from '../src/assets/img/menu/1.png';
import MenuImg2 from '../src/assets/img/menu/2.png';
import MenuImg3 from '../src/assets/img/menu/3.png';
import MenuImg4 from '../src/assets/img/menu/4.png';
import TeamImg from '../src/assets/img/team/team.png';
import Avatar1 from '../src/assets/img/testimonial/avatar1.png';
import Avatar2 from '../src/assets/img/testimonial/avatar2.png';
import Avatar3 from '../src/assets/img/testimonial/avatar3.png';
import HeroLogo from '../src/assets/img/tcp.png';
import SignatureImg from '../src/assets/img/team/frnds.png';
import coopi from '../src/assets/img/writeus/coopi.png';
import coopi1 from '../src/assets/img/writeus/coopi1.png';
import coopi2 from '../src/assets/img/writeus/coopi2.png';
import coopi3 from '../src/assets/img/writeus/coopi3.png';
import coopi4 from '../src/assets/img/writeus/coopi4.png';
import coopi5 from '../src/assets/img/writeus/coopi5.png';
import coopi6 from '../src/assets/img/writeus/coopi6.png';
import coopi7 from '../src/assets/img/writeus/coopi7.png';
import coopi8 from '../src/assets/img/writeus/coopi8.png';

export const navData = [
  { href: '/', name: 'home' },
  { href: '/', name: 'wanna know about us' },
  { href: '/', name: 'menu' },
  { href: '/', name: 'team' },
  { href: '/', name: 'testimonials' },
  { href: '/', name: 'book a table' },
  { href: '/', name: 'contact' },
];

export const heroData = {
  pretitleImage: (<img src={HeroLogo} alt="Pretitle_Image" />),
  title: 'The F.R.I.E.N.D.LIEST hangout spot in Colombo!',
  subtitle: 'Hours: 11 am to 11 pm ',
  btnText: 'yumminess',
};

export const photoBookData = {
  photopretitle: '"Some girl ate Monica!"',
  phototitle: 'photo book',
  photosubtitle:
    'Please kindly click on the button below to view all of our photos and updates on Instagram. Thank you!',
  photobtnText: 'visit us',
};

export const aboutData = {
  pretitle: '“How you doing?”',
  title: 'wanna know about us?',
  subtitle:
    'The Central Perk is a fantastic coffee shop in Colombo, Sri Lanka. It is an ideal spot for friends to catch up over great coffee, shisha, and tasty food. The coffee is top-notch, brewed with high-quality beans and served in a cozy and inviting atmosphere. The shisha lounge is a popular spot for relaxing and enjoying a variety of flavors in a comfortable setting. The menu offers a diverse range of local and international cuisine, catering to all tastes. The friendly staff and comfortable seating make The Central Perk the perfect hangout spot for friends.',
  btnText: 'buzz',
  image: AboutImg,
};

export const menuData = {
  title: 'Foodie favorites',
  subtitle: '“What’s not to like? Custard: good. Jam: good. Meat: good!”',
  sub1: `"There's a reason why Joy definitely won't share our food"`,
  menuItems: [
    {
      image: MenuImg1,
      name: 'D.R.I.N.K.S',
      description: 'Espresso, Frappe, Ice Fusion, Mocktails, Shakes, Tea',
    },
    {
      image: MenuImg2,
      name: 'F.O.O.D',
      description: 'Starters and Soups, Pasta, Mains, Sandwiches, Waffles, Cakes',
    },
    {
      image: MenuImg3,
      name: 'S.M.O.K.E.R.S L.O.U.N.G.E',
      description: 'Shisha, Add on flavors, Mint, Gum, Ice Mange, TCP bomb, TCP Fruit',
    },
    {
      image: MenuImg4,
      name: 'S.P.E.C.I.A.L',
      description: '“I don’t even have a ‘pla.’ ”',
    },
  ],
};

export const teamData = {
  pretitle: `"I'll Be There for You"`,
  title: 'our team',
  sub1: "Central Perk's staff is dedicated to providing top-notch service to every customer who walks through the door. With a warm smile and a can-do attitude, they go above and beyond to make sure that your coffee, tea, or snack is just the way you like it. Whether you're a regular or a first-time visitor, the staff at Central Perk will make you feel right at home.",
  occupation: '“Seven!”',
  TeamImg: TeamImg,
  signatureImg: SignatureImg,
};

export const contactData = {
  pretitle: '“They don’t know that we know they know we know.”',
  title: 'write us',
  sub1: "We appreciate your valuable feedback and are grateful for your input. Your comments will help us enhance our offerings and ensure that we continue to provide a top-notch experience for all our guests. Thank you for choosing us and for taking the time to share your thoughts.",
  coopi: coopi,
  coopi1: coopi1,
  coopi2: coopi2,
  coopi3: coopi3,
  coopi4: coopi4,
  coopi5: coopi5,
  coopi6: coopi6,
  coopi7: coopi7,
  coopi8: coopi8,
};

export const testimonialData = {
  title: "Testimonials",
  pretitle: '"I’m Chandler. I make jokes when I’m uncomfortable."',
  btnText: 'reed more',
  subtitle: '1500+ statisfied clients',
  slider: [
    {
      message:
        'One of the best places to hangout with friends. The place itself is a whole different vibe with a soothing interior. The best thing is that they’re having two separate floors for smokers and non-smokers....',
      image: Avatar1,
      name: '- Sakuni N',
    },
    {
      message:
        'I am not a fan of FRIENDS but its a nice cosy place. Good place to hang around with friends. Loved the Chicken Kochi Fries. Chicken Pasta portion could have been a little more. Panini quantity is....',
      image: Avatar2,
      name: '- Amalan D',
    },
    {
      message:
        'Being a fan of FRIENDS this is definitely one of my favourite places to hang out. The moment you walk in you will feel like walking into a FRIENDS Paradise....',
      image: Avatar3,
      name: '- Liana A.',
    },
    {
      message:
        'They were being so very helpful from the time I made the reservation till the end of the whole surprise party also playing a part in the surprise. Their customer service was on point and very down to earth....',
      image: Avatar2,
      name: '- Yashodha M.',
    },
  ],
};

export const footerData = {
  contact: {
    title: 'Location',
    address: '3784 patterson road, #8 new york, CA 69000',
    phone: '+94716418542',
    directions: 'Get Directions',
  },
  hours: {
    title: 'Business Hours',
    program: [
      {
        days: 'monday - sunday',
        hours: '11:00 AM - 11:00 PM',
      },
    ],
  },
  social: {
    title: 'social network',
    icons: [
      { href: '/', icon: <FaYoutube /> },
      { href: '/', icon: <FaFacebookF /> },
      { href: '/', icon: <FaInstagram /> },
      { href: '/', icon: <FaPinterestP /> },
      { href: '/', icon: <FaDiscord /> },
    ],
  },
};
